
/* injects from baggage-loader */
var Template = require('./template.js');

import {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {createSelector} from "reselect";

class HorseRacingEvent extends Component {
    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}

HorseRacingEvent.propTypes = {
    eventId: PropTypes.string,
    type: PropTypes.string,
    selectorKey: PropTypes.string,
    data: PropTypes.object,
    horseData: PropTypes.object
};

const mapStateToProps = (_, ownParams) => {
    const {type} = ownParams;
    return createSelector(
        [
            state => state.horseRacing.selections && JSON.stringify(state.horseRacing.selections.find(item => item.name.replace(/\s/g, '').toLowerCase() === type.replace(/\s/g, '').toLowerCase()))
        ],
        (horseDate) => {
            return {
                horseData: horseDate && JSON.parse(horseDate)
            };
        });
};

export default connect(mapStateToProps)(HorseRacingEvent);